import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Token } from "../../../Script/Session";
import { post } from "../../../Script/Session";
import { useNavigate } from "react-router-dom";
import NavigationBar from "../../../components/Navigationbar/Navigationbar";
import Sidebar from "../../../components/Sidebar/Sidebar";
import AddButton from "../../../components/buttons/createButton/CreateButton";
import EventCreateForm from "./Components/CreateForm/EventCreateForm";
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import Stylebutton from '../../../components/buttons/stylebutton/Stylebutton.jsx';
const EventVerwaltung = () => {
    const [wit, setwith] = useState("87.5%");
    const [data, setdata] = useState("{}");
    const [filteredata, setfilterdata] = useState("{}");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    function search() {
        console.log("search");
    }
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            try {
                const body = {
                    token: Token.get(),
                    action: "get",
                };

                const response = await post(body, "/EditEvents");

                if (!response) {
                    alert("GruppenVerwaltung hat einen Fehler!");
                    return;
                }

                if (response === "LOGOUT") {
                    navigate("/");
                    return;
                }

                const json = JSON.parse(response);
                setdata(json);
                setfilterdata(json.value);
                console.log(json.value);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        // Delay fetch slightly to avoid blocking render
        setTimeout(() => {
            fetchData();
        }, 0); // Immediate but non-blocking
    }, [navigate]);
    function del() {
        let body = {}
        body.event = parseInt(current);
        body.token = Token.get();
        body.action = "delete";
        let response = post(body, "/EditEvents")
        if (!response) {
            alert("Fehler");
        }
        if (response === "LOGOUT") {
            navigate("/");
        }
        if (response === "EXISTINGEVENT") {
            alert("Event existiert nicht!")
        }
        if (response === "OK") {
            alert("Event Gelöscht");
        }
    }
    function edit() {
        let body = {}
        body.event = current + "";
        body.token = Token.get();
        body.action = "edit";
        let a = prompt("Neue Punktzahl:");
        while (isNaN(a)) {
            a = prompt("Bitte Gültige Punktzahl angeben:");
        }
        body.amout = a + "";
        let response = post(body, "/EditEvents");
        if (response == "OK") {
            alert("Erfolgreich bearbeitet!")
            window.location.reload();
        }
        if (response == "EXISTINGEVENT") {
            alert("Event Existiert nicht!")
        }

    }

    const [current, setcurrent] = useState(null);
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
    const [isOpen, setIsOpen] = useState(false);
    const [hoveredit, sethoveredit] = useState(false);
    const [hoverdelete, sethoverdelete] = useState(false);
    const handleClick = (e) => {
        setTimeout(() => {
            console.log(e.clientX + " " + e.clientY);
            setMousePos({ x: "75%", y: e.clientY });
            setIsOpen(true);
            console.log("set open true");
        }, 5);
    };

    useEffect(() => {
        const handleClickOutside = () => {
            if (isOpen) {
                console.log("set outside false");
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('click', handleClickOutside);
        }
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isOpen]);
    const [createf, setcreatef] = useState(false);
    return (
        <>
            <header><title>Events || Verwaltung </title></header>
            <div><NavigationBar state="adminhome" back="inline" /></div>
            {isOpen && (
                <div
                    style={{
                        position: 'absolute',
                        top: mousePos.y,
                        left: mousePos.x,
                        backgroundColor: 'white',
                        width: '160px',
                        boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                        borderStyle: 'solid',
                        borderColor: 'gray',
                        borderWidth: '1px',
                        display: 'flex',
                        flexDirection: 'column',
                        zIndex: 1000,
                    }}
                >
                    {/* Löschen */}
                    <div
                        onMouseEnter={() => sethoveredit(true)}
                        onMouseLeave={() => sethoveredit(false)}
                        onClick={() => edit()}

                        style={{
                            height: '45px',
                            backgroundColor: hoveredit ? '#f0f0f0' : 'transparent',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            color: 'gray',
                            cursor: 'pointer',
                        }}
                    >
                        <>
                            <BorderColorOutlinedIcon style={{ marginLeft: '8%', marginRight: '8%' }} />
                            <p style={{ margin: 0 }}>Bearbeiten</p>
                        </>

                    </div>
                    <div
                        onMouseEnter={() => sethoverdelete(true)}
                        onMouseLeave={() => sethoverdelete(false)}
                        onClick={() => del()}
                        style={{
                            height: '45px',
                            backgroundColor: hoverdelete ? '#f0f0f0' : 'transparent',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            color: 'red',
                            cursor: 'pointer',
                        }}
                    >
                        <>
                            <DeleteOutlineOutlinedIcon style={{ marginLeft: '8%', marginRight: '8%' }} />
                            <p style={{ margin: 0, }}>Löschen</p>
                        </>
                    </div>
                </div>
            )}
            <div style={{ width: wit }} className='verwaltung-nutzer-container'>
                <div style={{
                    width: "95%",
                    backgroundColor: "#f7f7f7",
                    marginTop: "3.5%",
                    color: "white",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                    overflow: "visible"
                }}>
                    <div style={{
                        width: "100%",
                        height: "55px",
                        backgroundColor: "#2a3042",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        fontSize: "20px",
                    }}>
                        <p>Event Verwaltung</p>
                    </div>
                    <div
                        style={{
                            padding: "10px", width: "100%",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                        }}>
                        <div style={{
                            backgroundColor: "transparent",
                            height: "60px",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "black", flexDirection: "row", justifyContent: "space-evenly"
                        }}>
                            <form style={{ display: "flex", marginLeft: "1%", width: "30%", backgroundColor: "transparent", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }} onSubmit={search}>
                                <div style={{ display: "flex", marginRight: "5%", width: "120%" }} class="group">
                                    <svg class="icon" aria-hidden="true" viewBox="0 0 24 24"><g><path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path></g></svg>
                                    <input onChange={e => {
                                        if (!document.getElementById("oshafhasdfj2141904890asf").value) {
                                            //cancelsearch();
                                        }

                                    }} placeholder="Suchen" id="oshafhasdfj2141904890asf" type="search" class="input" />

                                </div>
                            </form>

                            <Stylebutton click={() => setcreatef(true)} buttonText={"Event Erstellen"} />
                        </div>

                        <div style={{
                            backgroundColor: "transparent",
                            width: "98%",
                            borderStyle: "solid",
                            borderColor: "black",
                            borderWidth: "1px",
                            borderColor: "lightgray",
                        }}>
                            <div style={{
                                width: "100%",
                                height: "40px",
                                backgroundColor: "white",
                                display: "flex",
                                color: "black",
                                fontSize: "15px",
                                alignItems: "center",
                                fontWeight: "bold",
                                borderBottom: "1px solid darkgray",
                            }}>
                                <p style={{ marginLeft: "1.5%" }}>Informationen:</p>
                                <p style={{ marginLeft: "75%" }}>Bearbeiten:</p>
                            </div>
                            {loading ? (
                                <p>Loading groups...</p>
                            ) : filteredata === 0 ? (
                                <p style={{ marginLeft: "1%" }}>Keine Gruppe Gefunden</p>
                            ) : data.value.length > 0 ? (
                                <ul style={{ width: "100%", overflowY: "auto", listStyle: "none", padding: "0px" }}>
                                    {filteredata
                                        .map((item, index) => (
                                            <li key={index} style={{ width: "100%" }}>
                                                <div style={{ width: "100%", minHeight: "50px", backgroundColor: "transparent", display: "flex", flexDirection: "row", color: "black" }}>
                                                    <div style={{ width: "33%" }}><p style={{ marginLeft: "5%" }}>{item.desc}</p></div>
                                                    <div style={{ width: "33%" }}><p style={{ marginLeft: "25%" }}>Zuzuteilende Punkte: {item.val}</p></div>
                                                    <div style={{ width: "33%" }}>
                                                        <div style={{ marginLeft: '55%', marginTop: "2%" }} onClick={(e) => { setcurrent(item.id); handleClick(e) }}><TuneOutlinedIcon /></div>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                </ul>
                            ) : (
                                <p>No User available</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {createf && (
                <EventCreateForm setmask={setcreatef} />
            )}
        </>
    )


}
export default EventVerwaltung;